import { render } from "./VlersimiPerformances.vue?vue&type=template&id=68d1f0f8&scoped=true"
import script from "./VlersimiPerformances.vue?vue&type=script&lang=js"
export * from "./VlersimiPerformances.vue?vue&type=script&lang=js"

import "./VlersimiPerformances.vue?vue&type=style&index=0&id=68d1f0f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d1f0f8"]])

export default __exports__